export const erbolatova = {
    id: "erbolatova",
    name: { ru: "Ерболатова Гульжаухар Мирамбековна", kz: "Ерболатова Гүлжаухар Мирамбекқызы" },
    position: { ru: "Спортивный врач", kz: "Спорт дәрігері" },
    department: "sportmed",
    image: "/team_photoes/Гульжаухар.svg",
    experience: {
      ru: "4 года",
      kz: "4 жыл"
    },
    education: {
      ru: `2010–2015 — Медицинский Университет Астана — Специальность Общая медицина
2015–2017 — Медицинский Университет Астана — Специальность Врач терапевт
2017–2020 — Медицинский Университет Астана — Специальность Врач кардиолог
2022 — Курс по оказанию первой помощи
2024 — Курс «Базовые основы ЭКГ. ЭКГ при патологиях сердца»`,
      kz: `Астана медицина университеті, «Жалпы медицина» мамандығы
2015–2017 — Астана медицина университеті, «Терапевт» мамандығы
2017–2020 — Астана медицина университеті, «Кардиолог» мамандығы
2022 — Алғашқы жәрдем көрсету курсы
2024 — «ЭКГ негіздері. Жүрек патологиялары кезіндегі ЭКГ» курсы`
    },
    specialization: {
      ru: `• Кардиология
• Терапия
• ЭКГ диагностика
• Первая помощь`,
      kz: `• Кардиология
• Терапия
• ЭКГ диагностика
• Алғашқы жәрдем`
    },
    work: {
      ru: `• 2020–2022 — ЦСО «ШАРАПАТ» акимата города Астана — Специальность «Врач терапевт-кардиолог»
• 2022–2023 — РГУ Главная военная поликлиника Министерства обороны РК — Специальность «Врач кардиолог»
• 2022 — по сегодняшний день — ГККП Спортивная медицинская клиника города Астана — Специальность «Врач кардиолог»`,
      kz: `• 2020–2022 — Астана қаласы әкімдігінің «Шарапат» әлеуметтік қызмет көрсету орталығы, «Терапевт-кардиолог» мамандығы
• 2022–2023 — ҚР Қорғаныс министрлігінің Бас әскери емханасы, «Кардиолог» мамандығы
• 2022 — қазіргі уақытқа дейін — Астана қаласының «Спорттық медицина орталығы» МКҚК, «Кардиолог» мамандығы`
    },
    certificates: {
      ru: `Дополнительные навыки:
• Языки: Казахский (родной), Русский (свободно), Турецкий (B1), Английский (со словарем)
• Навыки работы с ПК: Опытный пользователь (Microsoft Office, специализированное медицинское ПО)`,
      kz: `Қосымша дағдылар:
• Тілдер: Қазақ тілі (ана тілі), Орыс тілі (еркін), Түрік тілі (B1), Ағылшын тілі (сөздікпен)
• Компьютерлік дағдылар: Тәжірибелі пайдаланушы (Microsoft Office, мамандандырылған медициналық бағдарламалар)`
    }
  };
